import { render, staticRenderFns } from "./AccessSSO.vue?vue&type=template&id=1697c91a&scoped=true&"
import script from "./AccessSSO.vue?vue&type=script&lang=js&"
export * from "./AccessSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1697c91a",
  null
  
)

export default component.exports